import React, { useState, useContext } from 'react';
import { ThemeContext } from '../theme';

export default function KeywordInputField({ label, tags, onChange, scale = 1 }) {
  const theme = useContext(ThemeContext);
  const [input, setInput] = useState('');
  const s = (n) => Math.round(n * scale);

  const add = () => {
    const t = input.trim();
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setInput('');
  };

  const remove = (tag) => onChange(tags.filter(t => t !== tag));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: s(12) }}>

      {/* Label */}
      <div
        className="font-satoshi"
        style={{
          fontWeight: 700,
          fontSize: s(18),
          lineHeight: `${s(24)}px`,
          color: theme.text100,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </div>

      {/* Input container */}
      <div style={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap',
        border: `1.5px solid ${theme.inputBorder}`, borderRadius: 16,
        minHeight: 48, backgroundColor: theme.inputBg,
        padding: '8px 16px', gap: 8,
      }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, flex: 1, alignItems: 'center' }}>
          {tags.map(tag => (
            <span key={tag} style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              backgroundColor: theme.cardBg100, borderRadius: 4,
              padding: '4px 8px', fontSize: 14, color: theme.text100,
              fontFamily: 'Satoshi, sans-serif', fontWeight: 400,
            }}>
              {tag}
              <button
                onClick={() => remove(tag)}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer',
                  padding: 0, display: 'flex', alignItems: 'center', flexShrink: 0,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M10.5 3.5L3.5 10.5M3.5 3.5l7 7" stroke={theme.text400} strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
              </button>
            </span>
          ))}
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); }
            }}
            placeholder="Add..."
            className="font-satoshi"
            style={{
              border: 'none', outline: 'none', fontSize: 14,
              color: theme.text100, backgroundColor: 'transparent', minWidth: 48,
            }}
          />
        </div>
      </div>

    </div>
  );
}
